import ModalPanel from '@admin/components/modal_panel'
import Icon from '@admin/components/icon'
import Menu from '@admin/components/menu'
import PropTypes from 'prop-types'
import Settings from './settings'
import Fields from './fields'
import Rules from './rules'
import React from 'react'

class Page extends React.PureComponent {

  static propTypes = {
    changes: PropTypes.number,
    config: PropTypes.object,
    endpoint: PropTypes.string,
    fields: PropTypes.array,
    form: PropTypes.object,
    program: PropTypes.object,
    status: PropTypes.string,
    onPop: PropTypes.func,
    onPush: PropTypes.func,
    onSave: PropTypes.func,
    onUpdate: PropTypes.func
  }

  _handleSave = this._handleSave.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Menu { ...this._getMenu() } />
      </ModalPanel>
    )
  }

  _getDesign() {
    const { config, onPop, onPush, onUpdate } = this.props
    return {
      config,
      onPop,
      onPush,
      onUpdate
    }
  }

  _getFields() {
    const { config, fields, form, program } = this.props
    return {
      config,
      fields,
      form,
      program
    }
  }

  _getMenu() {
    return {
      type: 'pointing',
      items: [
        { label: 't(Fields)', component: <Fields { ...this._getFields() } /> },
        { label: 't(Settings)', component: <Settings { ...this._getSettings() } /> },
        { label: 't(Rules)', component: <Rules { ...this._getRules() } /> }
      ]
    }
  }

  _getPanel() {
    const { changes, form, status } = this.props
    return {
      showHeader: false,
      buttons: [
        {
          label: status === 'ready' ? 't(Save)' : <Icon icon="circle-o-notch fa-spin" />,
          color: 'blue',
          disabled: changes === 0,
          handler: this._handleSave
        },
        {
          label: 't(Preview)',
          color: 'blue',
          basic: true,
          link: form.url
        }
      ]
    }
  }

  _getSettings() {
    const { config, onPop, onPush, onUpdate } = this.props
    return {
      config, 
      onPop,
      onPush,
      onUpdate
    }
  }

  _getRules() {
    const { config, onPop, onPush, onUpdate } = this.props
    return {
      config, 
      onPop,
      onPush,
      onUpdate
    }
  }

  _handleSave() {
    const { config, endpoint } = this.props
    this.props.onSave(endpoint, config)
  }

}

export default Page
